<template>
    <v-container fluid>
        <v-row align="center" justify="center">
            <img
                style="max-height:30vh; margin-top:10vh"
                src="@/assets/kaista_logo.svg"
                alt="Kaista logo"
            />
        </v-row>
        <v-row align="center" justify="center" class="mt-5">
            <h1>Payment</h1>
        </v-row>
        <v-row align="center" justify="center" class="mt-5">
            <div class="text-center">
                <v-progress-circular
                    v-if="loading"
                    indeterminate
                    color="primary"
                    :size="50"
                    :width="5"
                    class="mb-3"
                ></v-progress-circular>
                <v-btn
                    v-else
                    large
                    color="primary"
                    @click="login"
                    :loading="loading"
                >
                    {{$t("login.loginButton")}}
                </v-btn>
                <p class="mt-3">
                    <span v-if="loading">{{ $t("login.redirectingMessage") || "Redirecting to login..." }}</span>
                    <span v-else>{{$t("login.redirectInfo")}}</span>
                </p>
            </div>
        </v-row>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            autoLoginAttempted: false
        };
    },
    methods: {
        async login() {
            this.loading = true;
            try {
                await this.$AuthService.signIn();
                // signIn handles the redirect, so we won't reach this point
                // The redirect will take the user to Azure AD and then back to /auth/callback
            } catch (error) {
                // Login error - suppressed for production
                this.loading = false;
            }
        }
    },
    async mounted() {
        // Check if user is already authenticated
        const isAuthenticated = await this.$AuthService.isAuthenticated();

        if (isAuthenticated) {
            this.$emit("loggedIn");
            return;
        }

        // Auto-login if not authenticated and haven't attempted yet
        if (!this.autoLoginAttempted) {
            this.autoLoginAttempted = true;
            // Small delay to show the UI briefly before redirecting
            setTimeout(() => {
                this.login();
            }, 500);
        }
    }
};
</script>

<style>

</style>
